import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import styles from './sidebar.module.scss';
import { Icon } from '@monorepo/base/src/components/icon/icon';
import { useEffect, useRef, useState } from 'react';

interface ISeparationItemList {
	mini?: boolean;
	title?: JSX.Element | string;
	routeList: string[];
	icon: string;
	color?: string;
	children: React.ReactNode; // the list items to show when expanded
}

export const SeparationItemList = ({ mini = false, title, routeList, icon, color, children }: ISeparationItemList) => {
	const { entityRoute } = useRoute();
	const isListActive = routeList.includes(entityRoute);
	const [isOpen, setIsOpen] = useState<boolean>(isListActive || localStorage.getItem(`sidebarTab-${title}`) === 'true');
	const [height, setHeight] = useState(0);
	const contentRef = useRef<HTMLUListElement>(null);

	useEffect(() => {
		if (!contentRef.current) {
			return;
		}

		if (isOpen) {
			const scrollHeight = contentRef.current.scrollHeight;
			setHeight(scrollHeight); // expand to full height
		} else {
			setHeight(0); // collapse
		}
	}, [isOpen]);

	const handleTabClick = () => {
		// save to local storage with the title as key
		localStorage.setItem(`sidebarTab-${title}`, JSON.stringify(!isOpen));
		setIsOpen(!isOpen);
	};
	return (
		<li className={``}>
			<div
				className={`${styles.itemWrapper} ${isListActive && isOpen ? styles.activeList : isListActive ? styles.activeList : isOpen ? styles.openListSection : ''}`}>
				<div className={`${styles.itemLink}`}>
					<div onClick={handleTabClick} className={`${styles.item}`}>
						<Icon
							className={`${styles.icon} ${styles.sectionListIcon} ${isOpen ? styles.openSectionListIcon : ''}`}
							isMFP
							color={color}
							size="18px">
							{icon}
						</Icon>
						{!mini && <span className={styles.itemTitle}>{title}</span>}
					</div>
				</div>
			</div>

			<ul
				ref={contentRef}
				style={{ height }}
				className={`${styles.sectionList} ${styles.list} ${styles.fullList} ${isOpen ? styles.sectionListOpen : ''}`}>
				{children}
			</ul>
		</li>
	);
};
